const DVRIcon = ({ strokeColor = "#808080" }) => {
  return (
    <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 795.1 795.1">
      <g id="Circles">
        <circle id="Grey_Bkg" data-name="Grey Bkg" fill="#4d4d4d" cx="397.55" cy="397.55" r="388.66"/>
        <circle 
          id="Grey" 
          fill="none" 
          stroke={strokeColor} 
          strokeWidth="50px" 
          strokeMiterlimit="10" 
          cx="397.55" 
          cy="397.55" 
          r="372.55"
        />
        <circle 
          id="White_Inner" 
          data-name="White Inner" 
          fill="none" 
          stroke="#fff" 
          strokeWidth="20px" 
          strokeMiterlimit="10" 
          cx="397.55" 
          cy="397.55" 
          r="343.4"
        />
      </g>
      <g id="Shapes">
        <g id="DVR">
          <path 
            fill="#fcfcfc" 
            d="M141.84,410.04c0-23.45-.01-46.1,0-68.74.02-19.73,14.58-34.57,34.42-34.57,146.92.01,293.84.08,440.76.23,23.43.02,36.26,13.1,36.26,36.31,0,37.47,0,74.94,0,112.42,0,17.52-12.53,31.63-30.16,32.02-33.14.73-66.3.63-99.46.64-112.96.05-225.91.05-338.86-.09-6.9,0-14.12-.28-20.64-2.24-14.27-4.28-22.23-15.93-22.3-30.69-.07-14.83-.01-29.65-.01-45.29M628.99,425.41c0-26.97.01-53.93,0-80.9,0-8.8-2.93-12.06-11.64-12.91-2.41-.24-4.85-.15-7.28-.15-107.87-.04-215.74-.08-323.6-.09-33.71,0-67.42.04-101.13.09-17.4.03-19.13,1.72-19.13,18.66,0,32.9,0,65.8,0,98.7,0,11.69,2.96,14.63,14.66,14.63,141.04,0,282.08,0,423.11,0,4.85,0,9.71.02,14.56,0,6.97-.03,10.34-3.74,10.41-10.52.09-8.63.02-17.26.02-27.51h0Z"
          />
          <path 
            fill="#fcfcfc" 
            d="M226.77,365.12c27.4-14.77,55.76,4.34,58.29,29.41,2.01,19.97-14.25,40.03-34.7,41.62-22.62,1.76-41.4-14.17-42.29-35.45-.64-15.36,5.45-26.95,18.71-35.57M259.21,401.58c1.2-10.43-5.73-18.31-14.62-16.63-6.93,1.31-10.98,5.7-11.35,12.5-.38,6.89,3.36,11.75,10.15,13.43,7.33,1.81,12.17-1.69,15.82-9.31h0Z"
          />
          <path 
            fill="#f9f9f9" 
            d="M452.9,387.6c8.75-4.02,16.01-2.14,18.76,4.39,2.9,6.88-.33,14.07-7.51,17.1-5.68,2.4-10.14.12-13.48-4.02-4.81-5.97-3.89-11.91,2.22-17.47h0Z"
          />
          <path 
            fill="#f9f9f9" 
            d="M578.05,407.95c-8.26,3.22-14.56,1.44-17.49-4.93-2.74-5.97-1.93-11.52,3.69-15.64,5.31-3.89,12.37-3.02,16.55,1.85,4.75,5.54,4.01,11.68-2.75,18.72h0Z"
          />
          <path 
            fill="#f9f9f9" 
            d="M507.16,405.74c-4.5-5.06-5.3-10.62-1.4-14.99,2.68-3.02,7.94-6.03,11.43-5.43,3.88.67,7.97,4.86,10.31,8.56,3.25,5.15-.11,9.77-4.15,13.22-5.39,4.59-10.75,3.69-16.19-1.36h0Z"
          />
        </g>
      </g>
    </svg>
  );
};

export default DVRIcon;